"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ArticleItem = require("./ArticleItem/ArticleItem");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.articleList-container {\n  display: 'flex';\n  flex-direction: 'column';\n  gap: '24px'; }\n  .articleList-container .external-articles-title {\n    border-top: 4px solid #8caddb;\n    color: #8caddb;\n    letter-spacing: 0.32px; }\n";
  const fileName = "ArticleList_ArticleList";
  const element = document.querySelector("style[data-sass-component='ArticleList_ArticleList']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const ArticleList = _ref => {
  let {
    item,
    lang
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "articleList-container"
  }, item?.articles_list?.map((el, index) => {
    return /*#__PURE__*/_react.default.createElement(_ArticleItem.ArticleItem, {
      key: index,
      item: {
        ...el,
        pictures_gallery: el.newsletter_image
      },
      lang: lang,
      isLast: index === item.articles_list.length - 1
    });
  }), item?.articles_ext_list?.length > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "external-articles-title sia-text-01 sia-padding-03-top sia-padding-02-left sia-padding-05-bottom"
  }, item.sia_newsletter_labels['cms.newsletter.external-links']), item?.articles_ext_list?.map((el, index) => {
    return /*#__PURE__*/_react.default.createElement(_ArticleItem.ExternalArticleItem, {
      key: index,
      item: el,
      isLast: index === item.articles_ext_list.length - 1
    });
  })));
};
var _default = exports.default = ArticleList;